<template>
  <div :class="['article-list-item']">
    <!-- 用户 -->
    <div v-if="showUser && layout != 'row'" class="top-user-box">
      <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" @click="goUserPage(item.user)" />
      <div class="r-wrapper" @click="goUserPage(item.user)">
        <div class="username">
          {{ item.user.username }}
          <user-tag-group class="mL5" :user="item.user" />
          <device-source class="mL5" :source="item.source" />
        </div>
        <span class="date">
          {{ item.updated_at | dateFormat("MM月DD日 HH:mm") }}
          <span>来自{{ item.last_ip_area }}</span>
        </span>
        <!--        <div class="date" v-else>{{ item.updated_at | dateFromNow }}</div>-->
      </div>
    </div>
    <!-- 文章 -->
    <div :class="['flex-box', `${item.thumb.length ? 'has-img' : ''}`, `flex-${layout}`]">
      <!-- 文章内容 -->
      <router-link
        :to="getJumpWikiDetailUrl(item.game_alias || item.game.alias, item.game_id || item.game.id, item.id, true)"
        :target="device.inApp ? '_blank' : '_self'"
      >
        <div class="text-box">
          <div class="title">
            <span v-if="item.type == 4 && isShowTag(item.tag)" :class="['tag-item', `tag-${item.tag}`]">
              {{ tagInfos[item.tag] }}
            </span>
            <i v-if="item.is_top" class="iconfont icon-zhiding"></i>
            <span v-html="xss(item.title)"></span>
          </div>
          <div class="desc" v-html="xss(handleSummary(item.summary))"></div>
        </div>
      </router-link>
      <!-- 缩略图 -->
      <div v-if="item.thumb.length" class="img-box">
        <template v-for="(img, index) in item.thumb.split(',')">
          <div v-if="layout == 'row' ? index < 1 : index < 3" :key="index" class="item">
            <router-link
              v-if="item.type == 19 && index == 0"
              :to="
                getJumpWikiDetailUrl(item.game_alias || item.game.alias, item.game_id || item.game.id, item.id, true)
              "
              target="_self"
            >
              <img v-lazy="handleImgSize(img, 'list')" alt="" />
              <i class="play-icon wiki-icon wiki-icon-video-play"></i>
            </router-link>
            <img
              v-else
              v-lazy="handleImgSize(img, 'list')"
              alt=""
              @click="$imgViewShow(item.thumb.split(','), index)"
            />
            <!-- 视频文章，播放icon -->
          </div>
        </template>
      </div>
      <!-- 文章评论 -->
      <div v-if="item.comment && item.comment.length" class="comment-box">
        <div class="comment-item" v-for="(comment, index) in item.comment" :key="index">
          <div class="user-header">
            <img
              class="comment-user-avatar"
              v-lazy="handleImgSize((comment.user && comment.user.avatar) || '', 'list')"
              alt=""
            />
            <span class="user-name">{{ comment.user.username }}</span>
            <device-source class="mL5" :source="comment.source" />
            <span class="mL5">{{ comment.created_at | dateFormat("MM月DD日 HH:mm") }}</span>
            <span class="mL5">来自{{ comment.last_ip_area }}</span>
          </div>
          <div class="comment-content">
            <div class="comment-info">{{ deleteHtmlStr(comment.content) }}</div>
            <div class="img-wrapper" v-if="getContentImgs(comment.content)">
              <template v-for="(img, index) in getContentImgs(comment.content)">
                <div
                  v-if="index < 3"
                  :key="index"
                  class="img-item"
                  @click="$imgViewShow(getContentImgs(comment.content), index)"
                >
                  <img :src="img" alt="" />
                  <div v-if="index == 2 && getContentImgs(comment.content).length > 3" class="mask">
                    +{{ getContentImgs(comment.content).length - 3 }}
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 文章数据 -->
    <div class="bottom-box">
      <div class="l-box">
        <span v-if="layout == 'row'" class="user">
          <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
          <span>{{ item.user.username }}</span>
        </span>
        <a v-if="showGame" class="game-name">
          <img v-lazy="handleImgSize(item.game.icon, 'mini')" alt="" />
          {{ item.game.name }}
        </a>
        <!--        <div v-if="layout != 'row'" class="view-count"><i class="iconfont icon-yanjing"/>{{ item.view_count }}</div>-->
      </div>
      <div class="data-box">
        <div @click.stop="onJumpComment(item)"><i class="iconfont icon-pinglun" /> {{ item.comment_count }}</div>
        <div :class="[item.is_like ? 'active' : '']" @click.stop="onLike(item)">
          <i class="iconfont icon-dianzan"></i>{{ item.like_count > 0 ? item.like_count : 0 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserTagGroup from "@/components/UserTag/UserTagGroup";
import DeviceSource from "@/views/wiki/components/deviceSource";
import { apiContentLike } from "@/api/contentApi";
import { newDebounce, getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  name: "articleListItem",
  mixins: [],
  props: {
    // 图片与标题布局  row, column
    layout: {
      type: String,
      default: "row"
    },
    item: {
      type: Object,
      default: () => {}
    },
    keyword: {
      type: String,
      default: ""
    },
    showUser: {
      type: Boolean,
      default: true
    },
    showGame: {
      type: Boolean,
      default: false
    },
    isUserHome: {
      type: Boolean,
      default: false
    }
  },
  model: {},
  components: { UserTagGroup, DeviceSource },
  data() {
    return {
      tagInfos: {
        3: "工会",
        4: "交友",
        5: "攻略",
        6: "提问"
      }
    };
  },
  computed: {
    isShowTag() {
      return val => {
        return val == 3 || val == 4 || val == 5 || val == 6;
      };
    }
    // getContentText () {
    //   return (html) => {
    //     let $content = document.createElement('div');
    //     $content.innerHTML = html;
    //     return $content.innerText;
    //   };
    // },
    // getContentImgs () {
    //   return (html) => {
    //     let $content = document.createElement('div');
    //     $content.innerHTML = html;
    //     let imgs = [];
    //     $content.querySelectorAll('img').forEach((img) => {
    //       imgs.push(img.getAttribute('src'));
    //     });
    //     return (imgs && imgs.length) ? imgs : null;
    //   };
    // }
  },
  methods: {
    getJumpWikiDetailUrl,
    // 服务端渲染，替代getContentText
    deleteHtmlStr(str = "") {
      return str.replace(/<[^>]*>/g, "");
    },
    // 服务端渲染，替代getContentImgs
    getContentImgs(str = "") {
      const patten = /<img[^>]+src=['"]([^'"]+)['"]+/g;
      let imgs = [];
      let temp = null;
      while ((temp = patten.exec(str)) != null) {
        imgs.push(temp[1]);
      }
      return imgs && imgs.length ? imgs : null;
    },
    goUserPage(user) {
      window.open(`/user/index/${user.uid}.html`);
    },
    onClick(e) {
      if (this.isUserHome) {
        e.stopPropagation();
        e.preventDefault();
        // let url = `//${this.item.game.alias}.gamekee.com/${this.item.id}.html`;
        // window.open(url);
      }
    },
    // handleArticle (item) {
    //   this.$router.push(`/${item.id}.html`, this.device.inApp ? '_blank' : '_self');
    // },
    // goPage (item) {
    //   if (this.device.inApp) {
    //     this.jsToApp('app_goDetail', JSON.stringify(item));
    //   } else {
    //     this.$router.push(`/${item.id}.html`);
    //   }
    // },
    handleSummary(text) {
      let str = text;
      if (this.keyword) {
        let reg = new RegExp(`${this.keyword}`, "gim");
        str = text.replace(reg, '<span style="color:red;">' + this.keyword + "</span>");
      }
      return str;
    },
    onLike: newDebounce(
      function(articleItem) {
        // if (!this.isLogin()) {
        //   return false;
        // }
        let params = {
          is_like: articleItem.is_like ? 0 : 1,
          origin_id: articleItem.id,
          type: 1
        };
        apiContentLike(params).then(res => {
          articleItem.is_like = params.is_like;
          if (params.is_like) {
            articleItem.like_count++;
          } else {
            articleItem.like_count--;
          }
        });
      },
      500,
      true
    ),
    onJumpComment(item) {
      const path = getJumpWikiDetailUrl(
        item.game_alias || item.game.alias,
        item.game_id || item.game.id,
        item.id,
        true
      );
      sessionStorage.setItem("jumpDetailAnchorId", "detail-comment-ancher");
      this.$router.push(path);
    }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.article-list-item {
  border-bottom: 1px solid @border-basic;
  margin-bottom: 12px;
  padding-bottom: 12px;
  display: block;

  .top-user-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 50%;
      cursor: pointer;
    }

    .r-wrapper {
      padding-left: 16px;
      font-size: 12px;
      cursor: pointer;
      .username {
        // max-width: 150px;
        margin-bottom: 4px;
        color: #2f2f2f;
        font-weight: 500;
        line-height: 20px;
      }

      .date {
        color: #999;
        font-weight: initial;
      }
    }
  }

  .flex-box {
    display: flex;
    padding-left: 55px;
    .comment-box {
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      padding: 16px;
      background-color: #f8f8f8;
      border-radius: 8px;
      .comment-item {
        width: 100%;
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .user-header {
          display: flex;
          align-items: center;
          color: #999;
          font-size: 12px;

          .user-name {
            color: #666;
            font-size: 14px;
          }
          .comment-user-avatar {
            width: 24px;
            height: 24px;
            margin-right: 8px;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        .comment-content {
          margin-top: 20px;
          padding-left: 32px;
          color: #333;
          font-weight: 400;
          line-height: 20px;
          font-size: 14px;
          .img-wrapper {
            display: flex;
            .img-item {
              width: 110px;
              height: 100px;
              cursor: pointer;
              position: relative;
              border-radius: 6px;
              overflow: hidden;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              & + .img-item {
                margin-left: 12px;
              }

              .mask {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: fade(#000, 70%);
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                font-size: 16px;
              }
            }
          }
        }
      }
    }
    &.flex-row {
      justify-content: space-between;

      .text-box {
        width: 100%;
      }

      &.has-img {
        .text-box {
          width: calc(100% - 110px);
        }
      }

      .img-box {
        width: 96px;
        height: 60px;
        img {
          width: 96px;
          height: 60px;
          border-radius: 6px;
          object-fit: cover;
        }
      }
    }

    &.flex-column {
      flex-direction: column;

      .img-box {
        display: flex;

        .item {
          position: relative;
          margin-right: 14px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            object-fit: cover;
          }
          .play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            display: inline-block;
            width: 36px;
            height: 36px;
          }
        }

        // @media screen and (max-width: 500px) {
        //   .item {
        //     width: calc((100% - 14px * 2) / 3);
        //     height: 90px;
        //   }
        // }

        @media screen and (min-width: 500px) {
          .item {
            width: 200px;
            height: 120px;
            max-width: calc((100% - (14px * 2)) / 3);
          }
        }
      }
    }

    .text-box {
      cursor: pointer;
      align-items: flex-start;
      .title {
        .ellipsis;
        display: flex;
        align-items: center;
        width: auto;
        margin-bottom: 10px;
        font-size: 16px;
        // line-height: 24px;
        color: #171717;
        font-weight: 500;
        .iconfont {
          font-size: 16px;
          margin-right: 5px;
          color: #e74957;
        }
        .tag-item {
          display: inline-block;
          width: 36px;
          height: 18px;
          margin-right: 8px;
          text-align: center;
          line-height: 18px;
          color: #fff;
          font-size: 12px;
          border-radius: 2px;
          &.tag-3 {
            background-color: #4d8bff;
          }
          &.tag-5 {
            background-color: #4d8bff;
          }
          &.tag-4 {
            background-color: #ed7272;
          }
          &.tag-6 {
            background-color: #de9e3c;
          }
        }
      }

      .desc {
        margin-bottom: 20px;
        font-size: 12px;
        color: #666;
        line-height: 18px;
        overflow: hidden;
        max-height: 36px;
      }
    }
  }

  .bottom-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    color: #575757;
    font-size: 12px;

    .l-box {
      display: flex;
      align-items: center;

      .game-name {
        font-size: 12px;
        color: #666;
        background: @border-basic;
        border-radius: 20px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        height: 22px;
        margin-right: 14px;

        img {
          width: 16px;
          height: 16px;
          border-radius: 2px;
          margin-right: 6px;
        }
      }

      .user {
        display: flex;
        align-items: center;

        img {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          object-fit: cover;
          margin-right: 8px;
        }
      }
    }

    .iconfont {
      margin-right: 4px;
      font-size: 12px;
    }

    div {
      display: flex;
      align-items: center;
    }

    .data-box {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      cursor: pointer;
      .active {
        .iconfont {
          color: #00afe8;
        }
      }
      > div {
        display: flex;
        align-items: center;
      }

      > div + div {
        margin-left: 12px;
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
